export function formatNumber(param: string | number) {
    const number = typeof param === 'string' ? parseFloat(param) : param;
    if (Number.isNaN(number)) {
        return param;
    }
    if (number > 999999) {
        return `${(number / 1000000).toFixed(2)}M`;
    }
    if (number > 99999) {
        return `${(number / 1000).toFixed(0)}K`;
    }
    return `${number}`;
}
